import { render } from "./ReleaseView.vue?vue&type=template&id=5c2be9b8"
import script from "./ReleaseView.vue?vue&type=script&lang=js"
export * from "./ReleaseView.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__